import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  Spinner,
  Heading,
  Grid,
  GridItem,
  Flex,
  Input,
} from "@chakra-ui/react";
import { getEmailContact } from "../utils/api"; // Ensure this utility is correctly implemented

const EmailsContacted = () => {
  const [emails, setEmails] = useState([]);
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const data = await getEmailContact(); // Fetch emails using the utility
        // Format the date into MM/DD/YYYY
        const formattedEmails = data.map((item) => ({
          email: item.email,
          sentDate: item.sentDate
            ? new Date(item.sentDate).toLocaleDateString("en-US")
            : "Unknown Date",
        }));

        setEmails(formattedEmails);
        setFilteredEmails(formattedEmails); // Set filtered emails initially
      } catch (err) {
        console.error("Error fetching rating emails:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEmails();
  }, []);

  // Handle search input change
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = emails.filter((email) =>
      email.email.toLowerCase().includes(value),
    );
    setFilteredEmails(filtered);
  };

  if (isLoading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (error) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Text color="red.500">{error}</Text>
      </Flex>
    );
  }

  if (emails.length === 0) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Text>No emails have been contacted yet.</Text>
      </Flex>
    );
  }

  return (
    <Box p={8} >
      <Text mb={4} color="#1c4b7e" className="h-text">
        Emails Contacted
      </Text>
      {/* Search Bar */}
      <Box mb={6}>
        <Input
          placeholder="Search by Email"
          width="25%"
          value={searchTerm}
          onChange={handleSearch}
          bg="white"
          boxShadow="0px 10px 20px rgba(0, 0, 0, 0.1)"
          rounded="lg"
          border="2px solid #1c4b7e"
          _focus={{
            borderColor: "#1c4b7e",
            boxShadow: "0 0 10px rgba(28, 75, 126, 0.5)",
          }}
          _hover={{
            borderColor: "#1c4b7e",
          }}
        />
      </Box>
      {/* Email Grid */}
      <Grid templateColumns="repeat(auto-fill, minmax(250px, 1fr))" gap={6}>
        {filteredEmails.map((item, index) => (
          <GridItem
            key={index}
            p={4}
            bg="white"
            boxShadow="0px 10px 20px rgba(0, 0, 0, 0.1), 0px 6px 6px rgba(0, 0, 0, 0.1)"
            rounded="lg"
          >
            <Text color="#1c4b7e" fontSize="md" fontWeight="bold">
              Email:
            </Text>
            <Text color="#1c4b7e" mb={2}>
              {item.email}
            </Text>
            <Text color="#1c4b7e" fontSize="md" fontWeight="bold">
              Date Sent:
            </Text>
            <Text color="#1c4b7e">{item.sentDate}</Text>
          </GridItem>
        ))}
      </Grid>
      {filteredEmails.length === 0 && (
        <Text mt={4} color="red.500">
          No emails match your search.
        </Text>
      )}
    </Box>
  );
};

export default EmailsContacted;
